module.exports = __webpack_public_path__ + "0f5845868f17d3a7ba62a53d80f338eb.svg";